import React, { FC, ReactNode } from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import { useTheme } from '@adsk/alloy-react-styles';
import { StylableComponent } from '@adsk/alloy-react-theme';

import { useTranslation } from '../../i18n';

type TableConfigurationResetProps = StylableComponent<HTMLButtonElement> & {
  label?: ReactNode;
  reset: () => void;
};
const TableConfigurationReset: FC<TableConfigurationResetProps> = ({
  label,
  reset,
}) => {
  const theme = useTheme();
  const resetButtonTokens =
    theme.tokens?.component?.table?.configuration?.resetButton;
  const { t } = useTranslation();
  const resetLabel = t('RESET_ALL');

  return (
    <LinkButton
      data-testid={'TableConfigurationMenu__ResetAll'}
      size={LinkButton.SIZES.SMALL}
      style={resetButtonTokens?._}
      onClick={reset}
    >
      {label || resetLabel}
    </LinkButton>
  );
};
TableConfigurationReset.propTypes = {
  label: PropTypes.any,
  reset: PropTypes.func.isRequired,
};

export default TableConfigurationReset;
